<!-- Footer START -->
<footer class="content-footer cb w-100">
  <div class="mobile-only footer-extension">
    <img class="logo" src="assets/cb/images/CB_Icon_white.svg" alt="CompanyBox Logo" />
    <div class="footer-h1">IMPORTANT LINKS</div>
    <img src="assets/cb/images/line_brown.svg" alt="" />
    <div class="link-list-container">
      <div class="link-list">
        <a href="https://www.companybox.com/products/">PRODUCTS</a>
        <a href="https://www.companybox.com/faq/">HELP</a>
        <a href="https://www.companybox.com/about/">ABOUT</a>
      </div>
      <div class="link-list">
        <a href="https://www.companybox.com/blog/">BLOG</a>
        <a [routerLink]="['/samples']">SAMPLES</a>
        <a href="https://www.companybox.com/faq/">FAQS</a>
      </div>
    </div>
    <div class="footer-h1">CONTACT US</div>
    <img src="assets/cb/images/line_brown.svg" alt="" />
    <div class="contact-list-container">
      <div class="footer-h2">13347 South Point Blvd, Charlotte, NC 28273</div>
      <a class="footer-h2" href="tel:+18779263223"><img src="assets/cb/images/call_p_icon_small.svg" alt="" />877.926.3223</a>
      <a class="footer-h2" href="mailto:info@companybox.com"
        ><img src="assets/cb/images/email_e_icon_white.svg" alt="" />EMAIL US</a
      >
    </div>
    <div class="footer-h1">FOLLOW US</div>
    <img src="assets/cb/images/line_brown.svg" alt="" />
    <div class="social-media-container">
      <a class="social-media-button" href="https://www.facebook.com/companybox/"
        ><img src="assets/cb/images/facebook_icon_white.svg" alt="Facebook"
      /></a>
      <a class="social-media-button" href="https://twitter.com/company_box"
        ><img src="assets/cb/images/twitter_icon_white.svg" alt="Twitter"
      /></a>
      <a class="social-media-button" href="https://www.instagram.com/companybox/"
        ><img src="assets/cb/images/instagram_icon_white.svg" alt="Instagram"
      /></a>
      <a class="social-media-button" href="https://www.linkedin.com/company/companybox%E2%84%A2/"
        ><img src="assets/cb/images/linkedin_icon_white.svg" alt="LinkedIn"
      /></a>
      <a class="social-media-button" href="https://www.pinterest.com/companybox/"
        ><img src="assets/cb/images/pinterest_icon_white.svg" alt="Pinterest"
      /></a>
    </div>
    <div class="copyright-text">
      Designed and Developed by
      <a href="https://captechconsulting.com/"><img src="assets/cb/images/captech_logo_white.svg" alt="CapTech Consulting" /></a>
    </div>
  </div>
  <div class="footer container-fluid">
    <div class="copyright row">
      <div class="col-8">
        <span
          >© 2023-2025 CompanyBox. All Rights Reserved. CompanyBox<sup>&reg;</sup> is a trademark of CompanyBox, LLC. in
          the United States and other countries.</span
        >
      </div>
      <div class="col-4 text-end">
        <a href="https://www.companybox.com/privacy-policy/">Privacy Policy</a> |
        <a href="https://www.companybox.com/terms-and-conditions/">Terms & Conditions</a>
      </div>
    </div>
  </div>
</footer>
<!-- Footer END -->
<ng-template #terms>
  <app-common-terms></app-common-terms>
</ng-template>

<ng-template #privacy_policy>
  <app-common-privacy-policy></app-common-privacy-policy>
</ng-template>
